import { render, staticRenderFns } from "./producer.vue?vue&type=template&id=4a4c3f58"
import script from "./producer.vue?vue&type=script&lang=ts"
export * from "./producer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports